// ─────────────────────────────────────────────────────────────
// CloudflareSync — Full two-way sync with Cloudflare R2
// Works exactly like the Google/Dropbox backup — mirrors all
// projects, samples, and soundfonts between OPFS and R2.
// ─────────────────────────────────────────────────────────────

import {Errors, RuntimeNotifier, RuntimeSignal} from "@opendaw/lib-std"
import {CloudBackup, ProjectSignals} from "@opendaw/studio-core"
import {CloudflareHandler} from "./CloudflareHandler"

export namespace CloudflareSync {

    export const sync = async (): Promise<void> => {
        const handler = new CloudflareHandler()

        // Verify worker is reachable first
        try {
            await handler.alive()
        } catch {
            await RuntimeNotifier.info({
                headline: "Cloudflare Unavailable",
                message: "Could not reach the Cloudflare DAW worker. Check your connection and try again."
            })
            return
        }

        try {
            // Use the same backupWithHandler flow as Google/Dropbox.
            // This gives us the identical progress dialog, lock system,
            // upload/download/trash logic — everything — for free.
            await CloudBackup.backupWithHandler(handler, "Cloudflare")

            await RuntimeNotifier.info({
                headline: "Cloudflare Sync",
                message: "Everything is up to date."
            })
        } catch (reason: unknown) {
            if (Errors.isAbort(reason)) return
            console.warn("[CloudflareSync]", reason)
            await RuntimeNotifier.info({
                headline: "Cloudflare Sync Failed",
                message: String(reason)
            })
        } finally {
            RuntimeSignal.dispatch(ProjectSignals.StorageUpdated)
        }
    }
}
